import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

const useRequestFromPage = (): boolean => {
  const { pathname } = useLocation();
  const [isRequestFormPage, setIsRequestFormPage] = useState(false);

  useEffect(() => {
    const isFormOpened =
      pathname.includes('create') ||
      pathname.includes('edit') ||
      pathname.includes('confirm');

    setIsRequestFormPage(isFormOpened);
  }, [pathname]);

  return isRequestFormPage;
};

export default useRequestFromPage;
